<div class="wrapper">
  <app-markup-rules-table
    mode="global"
    [rules]="dataSource"
    [loading]="loading"
    [readonly]="!isAdmin"
    [allowRecalculate]="isAdmin"
    [recalculating]="loadPrice"
    [sortable]="true"
    (createRule)="add()"
    (editRule)="update($event)"
    (deleteRule)="remove($event)"
    (refreshRules)="load()"
    (recalculate)="updatePrices()"
    (sortChange)="sortData($event)"
  ></app-markup-rules-table>
</div>
